<template>
  <td>
    <input
      :type="type"
      v-model.trim="model"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
    />
  </td>
</template>

<script setup lang="ts">
const props = defineProps({
  //name: { type: String, required: true },
  placeholder: { type: String },
  disabled: { type: Boolean },
  readonly: { type: Boolean },
  type: { type: String, default: 'text' }
})

const model = defineModel<any>({ required: true })
</script>

<style lang="css" scoped>
input {
  width: 100%;
  height: 2rem;
  border: none;
  outline: none;
  padding-left: 0.25rem;
  /*font-size:large;*/
}
input:focus {
  /*background-color: lightsteelblue;*/
  border: 1px solid var(--blue);
}

td {
  padding: 0;
  margin: 0;
}
</style>
